import { Cluster, UpgradePlan, UpgradeTemplate } from 'api/models';
import { getClusterProvider } from './clusterStates';
import * as Sentry from '@sentry/browser';

export function filterUpgradePlansByResources(upgradePlans: UpgradePlan[]) {
  const addonUpgradePlans: UpgradePlan[] = [];
  const clusterUpgradePlans: UpgradePlan[] = [];

  upgradePlans?.forEach((plan) => {
    const addonResourcesCount =
      (plan.resources?.addons || []).length +
      (plan.resources?.addon_instances || []).length;

    if (addonResourcesCount === 0) {
      clusterUpgradePlans.push(plan);
    } else {
      addonUpgradePlans.push(plan);
    }
  });

  return {
    addonUpgradePlans,
    clusterUpgradePlans,
  };
}

export function filterUpgradeTemplatesByResources(
  upgradeTemplates: UpgradeTemplate[],
) {
  const addonUpgradeTemplates: UpgradeTemplate[] = [];
  const clusterUpgradeTemplates: UpgradeTemplate[] = [];

  upgradeTemplates?.forEach((template) => {
    const addonResourcesCount =
      (template.resources?.addons || []).length +
      (template.resources?.addon_instances || []).length;

    if (addonResourcesCount === 0) {
      clusterUpgradeTemplates.push(template);
    } else {
      addonUpgradeTemplates.push(template);
    }
  });

  return {
    addonUpgradeTemplates,
    clusterUpgradeTemplates,
  };
}

export const LATEST_K8S_VERSION_PREFIX = '1.36';
export function isLatestVersion(version: string): boolean {
  return (
    version.startsWith(LATEST_K8S_VERSION_PREFIX) ||
    version.startsWith(`v${LATEST_K8S_VERSION_PREFIX}`)
  );
}

export const getCloudProviderFromClusterUT = (
  template: UpgradeTemplate,
  clusters: Cluster[],
): string => {
  const utClusterId = template.resources?.clusters?.[0]?.id;
  if (utClusterId && clusters) {
    const utCluster = clusters.find((c) => c.id === utClusterId);
    if (utCluster) {
      return getClusterProvider(utCluster);
    }
  } else {
    Sentry.captureException('No cluster found for upgrade template', {
      extra: {
        template,
        clusters,
      },
    });
  }
  return 'unknown';
};
